export default __webpack_public_path__ + "f2c9a3302aeac9b8d977d7945a49394b.png";